import { Badge } from "@/components/ui/badge";

interface StatusBadgeProps {
  value?: boolean;
  trueLabel?: string;
  falseLabel?: string;
}

export function StatusBadge({
  value,
  trueLabel = "Yes",
  falseLabel = "No",
}: StatusBadgeProps) {
  if (value === undefined) {
    return (
      <Badge variant="outline" className="bg-gray-100 text-gray-600">
        N/A
      </Badge>
    );
  }

  return (
    <Badge
      className={
        value
          ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
          : "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
      }
    >
      {value ? trueLabel : falseLabel}
    </Badge>
  );
}
